import { BADGES } from "../../data/badges";
import { bind, bindActivate } from "../dom";
import { esc, todayKey } from "../helpers";
import { t } from "../i18n";
import type { Screen, ScreenContext } from "./context";

/** The home screen: team name, the Daily/Free packs, past seasons, and nav. */
export function renderMenu(ctx: ScreenContext): Screen {
  const T = t();
  const state = ctx.state;
  const hist = state.history.length
    ? `<h2 style="margin-top:26px">${T.pastSeasons}</h2><table><tr><th>${T.thWdc}</th><th>${T.thWcc}</th></tr>${state.history
        .map(
          (h) =>
            `<tr class="${h.playerWonWcc ? "you" : ""}"><td>${esc(h.wdc)}</td><td>${esc(h.wcc)}${h.playerWonWcc ? " ◈" : ""}</td></tr>`,
        )
        .join("")}</table>`
    : "";
  // The Daily pack's line reflects today's state: already played (with the
  // final position), forfeited, or still available.
  const dailyCost = (() => {
    const done = ctx.todaysDaily();
    if (done) return `<div class="cost">${T.dailyPlayed(ctx.playerWccPos(done))}</div>`;
    if (state.dailyFailedDay === todayKey()) return `<div class="cost">${T.dailyFailed}</div>`;
    return `<div class="cost">${T.dailyCost}</div>`;
  })();
  const html = `<div class="fade">
      <h2>${T.menuTitle}</h2>
      <p class="sub">${T.menuSub}</p>
      <p class="teamline" style="margin:-6px 0 16px;font-size:13px;color:var(--muted)">${T.teamLabel}: <b style="color:var(--txt)">${esc(state.teamName || "My Team")}</b> <button class="btn ghost" id="editNameBtn" style="padding:2px 10px;font-size:12px;margin-left:6px">✎ ${T.editName}</button></p>
      <div style="display:flex;gap:12px;flex-wrap:wrap;max-width:560px">
        <div class="pack" id="dailyPack" role="button" tabindex="0" aria-label="${esc(T.dailyTitle)}" style="flex:1;min-width:200px;border-color:var(--gold)">
          <h3>${T.dailyTitle}</h3>
          ${dailyCost}
        </div>
        <div class="pack" id="freePack" role="button" tabindex="0" aria-label="${esc(T.freeTitle)}" style="flex:1;min-width:200px">
          <h3>${T.freeTitle}</h3>
          <div class="cost">${T.freeCost}</div>
        </div>
      </div>
      <p class="hint">${T.menuHint} ${T.menuHowToNudge}</p>
      ${hist}
      <div class="row" style="margin-top:24px">
        <button class="btn ghost" id="howToBtn">❔ ${T.howToNav}</button>
        <button class="btn ghost" id="badgesBtn">🏅 ${T.badgesNav} (${state.unlockedBadges.length}/${BADGES.length})</button>
        <button class="btn ghost" id="suggestBtn">💡 ${T.suggestNav}</button>
        <button class="btn ghost" id="resetBtn">${T.resetProgress}</button>
      </div>
    </div>`;
  return {
    html,
    bind() {
      bindActivate("dailyPack", ctx.actions.startDaily);
      bindActivate("freePack", ctx.actions.startDraft);
      bind("editNameBtn", "click", ctx.actions.openRename);
      bind("resetBtn", "click", ctx.actions.reset);
      bind("howToBtn", "click", ctx.actions.showHowTo);
      bind("suggestBtn", "click", ctx.actions.showSuggest);
      bind("badgesBtn", "click", ctx.actions.openBadges);
    },
  };
}
